import clsx from "clsx";
import Link from "next/link";

import { ChevronLeft } from "@chef/icons/small";
import { PageLinkButton } from "@chef/smart-components";

import { LINK, PAGE, SHARED_BRAND } from "../utils";

interface MyAccountLayoutProps {
  page: PAGE;
  title?: string;
  children: React.ReactNode;
  hideBackOnMobile?: boolean;
}

export const MyAccountLayout = ({
  page,
  title: overrideTitle,
  children,
  hideBackOnMobile,
}: MyAccountLayoutProps) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const title: string = SHARED_BRAND.LINKS.find(
    (l: LINK) => l.page === page,
  ).title;

  return (
    <>
      <div
        className={clsx(
          "mb-8 md:mb-10 col-span-full md:col-start-4",
          hideBackOnMobile && "hidden lg:inline",
        )}
      >
        <h1 className="hidden text-3xl md:block">
          <strong>{overrideTitle || title}</strong>
        </h1>

        <div className="md:hidden">
          <Link
            href={SHARED_BRAND.MY_ACCOUNT_HREF}
            className="flex items-center gap-3"
          >
            <ChevronLeft />
            <span>
              <strong>{SHARED_BRAND.MY_ACCOUNT_TITLE}</strong>
            </span>
          </Link>
        </div>
      </div>

      <ul className="flex-col hidden col-span-3 md:flex">
        {SHARED_BRAND.LINKS.map((l: LINK) => {
          return (
            <PageLinkButton key={l.page} {...l} id={l.page} Icon={<l.Icon />} />
          );
        })}
      </ul>

      {children}
    </>
  );
};
